// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qtgu","col":"styles_col__3b3E4"};